import { useInkind } from '@gik/api/inkinds/inkind';
import { openPremiumPageThankYouModal } from '@gik/checkout';
import { openPremiumPageUpgradeModal } from '@gik/inkind-page';
import { useInkindStore } from '@gik/inkind/store/InkindStore';
import { Button, SvgIcon, SvgIconName } from '@gik/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';

export default function InkindPageSettingsPremiumBadge() {
  const inkindRouteId = useInkindStore(state => state.inkindRouteId);
  const { data: inkindPage } = useInkind(inkindRouteId);
  const { t } = useTranslation();

  const icon: SvgIconName = inkindPage?.isPremium ? 'Star' : 'StarOutline';
  const text = inkindPage?.isPremium
    ? t(translationKeys.inkindPageSettingsPremiumPageBadgeText)
    : t(translationKeys.inkindPageSettingsUpgradeBadgeText);
  const variant = inkindPage?.isPremium ? 'premium-unlocked' : 'premium-locked';

  function onPremiumButtonClick() {
    openPremiumPageThankYouModal();
  }

  function onUpgradeButtonClick() {
    openPremiumPageUpgradeModal({ initiatedOn: 'inkindPage', variant: 'generic' });
  }

  const onClick = () => (inkindPage?.isPremium ? onPremiumButtonClick() : onUpgradeButtonClick());

  return (
    <Button pill onClick={onClick} prepend={<SvgIcon name={icon} />} variant={variant} size="sm">
      {text}
    </Button>
  );
}
